<template>
  <div style="position: relative" :class="{ menuNavigationPadding: enableNavigation && screenSizeId < 3 }" @click="$emit('onClick')">
    <ks-overlay ref="requestPerformanceLogs" position="left">
      <ks-request-performance-logs />
    </ks-overlay>

    <ks-confirm ref="ks_active_page_confirm">
      <div class="card">
        <div class="card-body">
          The selected campaign(s) does not have permission for this page.
          <br />
          Please Select other campaign(s) with the correct permission.
          <br />
          <small class="text-danger">Required: {{ pageRequiredPermissions }}</small>
        </div>
      </div>
    </ks-confirm>

    <ks-menu-view-navigation :type="enableNavigation ? 'cards' : null" />
    <template v-if="ready">
      <slot></slot>
      <div
        class="page-header d-flex flex-row justify-content-between align-items-center"
        :class="{
          padleft: !app.leftDrawerStatus.isOpen,
          padright: !app.rightDrawerStatus.isOpen,
          [headerClasses]: true,
          sticky: stickyHeader,
          'sticky-left': stickyHeader && screenSizeId >= 3 ? leftDrawerOpen : false,
          'sticky-right': stickyHeader && screenSizeId >= 3 ? rightDrawerOpen : false,
        }"
        v-if="false"
        style="height: 70px; min-height: 70px; max-height: 70px; z-index: 2"
      >
        <h5 class="mb-0 mr-1" v-if="title">{{ title }}</h5>
        <slot name="header"></slot>
      </div>

      <div class="row" v-if="!multiCampaign && showCampaignSelector">
        <div class="col-md-3">
          <div class="form-group">
            <label>Active Campaign</label>
            <rms-single-campaign-selector :readOnly="multiCampaignReadOnly" />
          </div>
        </div>
      </div>

      <div :class="[bodyClasses, { padtop: stickyHeader }]" :style="{ padding: bodypadding }" v-if="hasSlotBody">
        <template v-for="(alert, index) in alerts" :showIfHasPermission="['rms.developer', 'rms.qa_tester']">
          <ks-alert
            :type="alert.type ? alert.type : 'primary'"
            :hideIn="alert.hideIn ? alert.hideIn : null"
            :closable="alert.closable ? alert.closable : true"
            @onHide="hideAlert($event, index)"
          >
            <div v-html="alert.body"></div>
          </ks-alert>
        </template>
        <slot name="body"></slot>
      </div>

      <template v-for="(toast, index) in toasts">
        <ks-toast
          :open="true"
          :styles="`position: fixed; top: ${65 + index * 55}px; left: 20px;`"
          :showHeader="false"
          :body="toast.body"
          :type="toast.type ? toast.type : null"
          :onClick="toast.onClick ? toast.onClick : () => {}"
          :autohide="toast.autohide ? toast.autohide : null"
          :defaultHide="false"
          :showClose="toast.showClose"
          :showBodyClose="toast.showClose"
          @onHide="hideToast($event, index)"
        ></ks-toast>
      </template>

      <!-- page confirm modal -->
      <ks-modal ref="ks_confirm_modal" :backdropClose="false" :enableClose="false" :title="confirm.title">
        <ks-modal-body>
          <div class="d-flex flex-row justify-content-center" v-html="confirm.body"></div>
        </ks-modal-body>
        <ks-modal-footer>
          <template v-if="confirm.buttons && confirm.buttons.length > 0">
            <button
              v-for="(button, index) in confirm.buttons"
              :class="`btn btn-${button.type}`"
              @click="onClickConfirm(typeof button.value !== 'undefined' ? button.value : index)"
              :key="`ks-confirm-modal-button-${index}`"
            >
              {{ button.label }}
            </button>
          </template>
          <template v-else>
            <button class="btn btn-primary" @click.prevent="onClickConfirm(true)">Accept</button>
            <button class="btn btn-danger" @click.prevent="onClickConfirm(true)">Cancel</button>
          </template>
        </ks-modal-footer>
      </ks-modal>
    </template>
    <ks-spinner ref="ref_loading_page" />
    <ks-merchant-transaction-modal ref="ref_transaction_modal" />
  </div>
</template>

<script>
  import alert from '../alert';
  import spinner from '../spinner';
  //import rms_ui from 'rms_ui'
  import merchantTransactionModal from '../merchant-transaction-modal';
  import validatePermissions from 'rms_ui/src/helpers/validatePermissions';
  import Vuex from 'vuex';

  export default {
    name: 'ks_page',
    components: {
      //...rms_ui,
      'ks-merchant-transaction-modal': merchantTransactionModal,
      'ks-spinner': spinner,
      'ks-alert': alert,
    },
    props: {
      showHeader: {
        type: Boolean,
        default: false,
      },
      enableNavigation: {
        type: Boolean,
        default: false,
      },
      activeView: {
        type: String,
        deafult: null,
      },
      multiCampaignReadOnly: {
        type: Boolean,
        default: true,
      },
      showCampaignSelector: {
        type: Boolean,
        default: false,
      },
      multiCampaign: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: null,
      },
      headerClasses: {
        type: String,
        default: null,
      },
      bodyClasses: {
        type: String,
        default: '',
      },
      stickyHeader: {
        type: Boolean,
        default: false,
      },
      bodypadding: {
        type: String,
        default: '',
      },
      confirmRecordChanges: {
        type: String,
        default: null,
      },
      beforeClose: {
        type: Function,
        default: null,
      },
    },
    computed: {
      pageRequiredPermissions() {
        return this.$route.meta.middlewares && this.$route.meta.middlewares.length > 0
          ? this.$route.meta.middlewares[0]['rms_ui/validatePermissionsMiddleware'][0]
          : null;
      },
      loading: {
        get: () => {
          return app.store.state.ks_app.global_data.loading;
        },
        set: value => {
          app.store.commit('ks_app/global_data/setLoading', value);
        },
      },
      screenSizeId() {
        return app.layout.screenSizeId;
      },
      data_provider_ref() {
        return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
      },
      dataProvider() {
        return this.$parent.dataProvider ? this.$parent.dataProvider : null;
      },
      hasSlotHeader() {
        return !!this.$slots.header;
      },
      hasSlotBody() {
        return !!this.$slots.body;
      },
      hasSlotFooter() {
        return !!this.$slots.footer;
      },
      app() {
        return app;
      },
      leftDrawerOpen() {
        return app.leftDrawerStatus.isOpen;
      },
      rightDrawerOpen() {
        return app.rightDrawerStatus.isOpen;
      },
      ...Vuex.mapGetters({ selected_campaigns: 'rms_ui/auth/selected_campaigns' }),
      callLogCount: {
        get: function () {
          return app.store.state.rms_ui.auth.call_log_count;
        },
        set: function (newValue) {
          app.store.commit('rms_ui/auth/setCallLogCount', newValue);
        },
      },
    },
    watch: {
      selected_campaigns: {
        handler() {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.validatePagePermissions();
          }, 1000);
        },
        deep: true,
      },
      loading: function (val) {
        if (val) {
          //if (this.$refs.ref_loading_page) this.$refs.ref_loading_page.show();
        } else {
          if (this.$refs.ref_loading_page) this.$refs.ref_loading_page.hide();
        }
      },
      activeView: function (val) {
        this.setCurrentView(val);
      },
      views: {
        handler: function (val, oldVal) {
          this.setCurrentView(this.activeView);
        },
        deep: true,
      },
    },
    beforeCreate() {
      this.$emit('onBeforeCreated', this);
    },
    created() {
      this.$emit('onCreated', this);
    },
    beforeMount() {
      this.$emit('onBeforeMount', this);
    },
    mounted() {
      //this.$refs.ref_loading.show();
      app['activePage'] = this;
      // reload mode components
      app['mode_components'] = [];
      this.$emit('onMounted', this);
      this.initAlerts();

      setTimeout(() => {
        this.verifyNotificationSubscription();
      }, 3000);

      setTimeout(() => {
        //verify the permissions of the page
        this.validatePagePermissions();
        //this.setActiveSingleCampaign();
        this.ready = true;
        //TODO add a prop to do this or not
        app.closeLeftDrawer();
        if (this.$refs.ref_loading) this.$refs.ref_loading.hide();
        this.$emit('onReady', this);
      }, 500);
    },
    methods: {
      verifyNotificationSubscription() {
        try {
          if (app.auth.isAuth) {
            // verify subscription permissions
            app.webPushNotification.getSubscription();
          }
        } catch (err) {
          console.log(err);
        }
      },
      validatePagePermissions() {
        try {
          if (this.$route.path != '/login') {
            //not validate permissions to login page
            let campaignIds = this.selected_campaigns ? this.selected_campaigns.map(c => c.id) : [];
            if (this.pageRequiredPermissions) {
              let res = validatePermissions(this.pageRequiredPermissions, campaignIds);
              if (res.isValid) {
                this.$refs['ks_active_page_confirm'].close();
              } else {
                this.$refs['ks_active_page_confirm'].open();
              }
            } else {
              if (this.$refs['ks_active_page_confirm']) this.$refs['ks_active_page_confirm'].close();
            }
          }
        } catch (err) {
          console.log(err);
        }
      },
      setCurrentView(vw) {
        let activeView = this.views.filter(view => view.viewName == vw)[0];
        this.currentView = activeView ? activeView : {};
      },
      // alert events
      openAlert(config) {
        this.alerts.push(config);
      },
      hideAlert(alert, index) {
        this.alerts.splice(index, 1);
      },
      initAlerts() {
        let alerts = window.localStorage.getItem(app.store.state.rms_ui.auth.auth.suffix + 'alerts');
        if (alerts) {
          alerts = JSON.parse(alerts);
          if (alerts && Array.isArray(alerts)) this.alerts = [...this.alerts, ...alerts];
          window.localStorage.removeItem(app.store.state.rms_ui.auth.auth.suffix + 'alerts');
        }
      },
      // toast events
      openToast(config) {
        this.toasts.push(config);
      },
      hideToast(toast, index) {
        console.log('xxx', this.toasts, index);
        this.toasts.splice(index, 1);
        console.log('xxx', this.toasts);
      },
      initToast() {
        let toasts = window.localStorage.getItem(app.store.state.rms_ui.auth.auth.suffix + 'toasts');
        if (toasts) {
          toasts = JSON.parse(toasts);
          if (toasts && Array.isArray(toasts)) this.toasts = [...this.toasts, ...toasts];
          window.localStorage.removeItem(app.store.state.rms_ui.auth.auth.suffix + 'toasts');
        }
      },
      //confirm modal
      openConfirm(title = null, body = null, buttons = []) {
        this.confirm = {
          title: title,
          body: body,
          buttons: buttons,
        };
        this.$refs.ks_confirm_modal.show();
        return new Promise((resolve, reject) => {
          this.confirmResolve = resolve;
        });
      },

      openRequestPerformanceLogs() {
        app.activePage.$refs.requestPerformanceLogs.open();
      },

      closeRequestPerformanceLogs() {
        app.activePage.$refs.requestPerformanceLogs.close();
      },

      onClickConfirm(value) {
        this.confirmResolve(value);
        this.$refs.ks_confirm_modal.hide();
        this.confirm = {
          title: null,
          body: null,
          buttons: [],
        };
        this.confirmResolve = null;
      },
    },
    data() {
      return {
        ready: false,
        timeout: null,
        currentView: {},
        views: [],
        alerts: [],
        toasts: [],
        confirm: {
          title: null,
          body: null,
          buttons: [],
        },
        confirmResolve: null,
        /*toastAlertConfig:{
        styles:"position: fixed; top: 65px; right: 25px;",
        bodyStyle:"background-color: #ffc107 !important",
        autohide: false,
        showClose: true,
        body:"sasasas Hello!",
        onClick: (cp, evt) => { console.log('click into notification', cp); }
      }*/
      };
    },
  };
</script>

<style>
  .page-header {
    padding: 0.75rem 10px;
    margin: 0 -15px;
    background-color: #efefef !important;
    border-bottom: 1px solid lightgray !important;
  }
  .padleft {
    padding-left: 50px !important;
  }
  .padright {
    padding-right: 25px !important;
  }
  .sticky {
    position: fixed;
    top: 60px;
    left: 0px;
    z-index: 1;
    width: 100%;
  }
  .sticky-left {
    padding-left: 430px;
  }
  .sticky-right {
    padding-right: 400px;
  }
  .padtop {
    padding-top: 69px !important;
  }
  .menuNavigationPadding {
    padding-top: 41px;
  }
</style>
